import React from "react";
import Button from "../atoms/Button";

interface RatingButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {}

const RatingButton: React.FC<RatingButtonProps> = (props) => {
  return (
    <Button
      className="sharing-button"
      imgSrc="/images/Star.svg"
      imgAlt="rate icon"
      label="rate"
      {...props}
    ></Button>
  );
};

export default RatingButton;
